import React, { useState, useEffect } from 'react';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { FxmsData } from "../../fxms/datas/FxData";
export const FxIndcManagerChartBar = (props) => {
  const { thisMon, BeforeMon, month, beforeMonth, engId } = props;
  const [resultArr, setResultArr] = useState([]);

  
  
  let engList = FxmsData.getDatas("energy");

  let engUnit = "";
  let engName = "";
  engList.forEach((obj) => {
    if(obj.engId == engId)
    {
      engUnit = obj.engUnit
      engName = obj.engName 
    }
  });
  

  useEffect(() => {
    showMonthEngAmt();
  }, [thisMon, BeforeMon]);

  /**
  * 월간 에너지 사용량
  * @param {*} inputData
  */
  const showMonthEngAmt = async (inputData) => {
    let arr = null;
    let arr2 = null;

    engList.forEach(item => {
      if (!thisMon[item.engId]) {
        thisMon[item.engId] = { engId: item.engId, consUsageVal: 0, yyyymm: month };
      }
      if (beforeMonth!=null && !BeforeMon[item.engId]  ) {
        BeforeMon[item.engId] = { engId: item.engId, consUsageVal: 0, yyyymm: beforeMonth };
      }
    });

    if(beforeMonth!=null) arr = Object.values(BeforeMon);
    arr2 = Object.values(thisMon);

    console.log("BeforeMon >>>>", arr);
    console.log("thisMon >>>>", arr2);

    const result = [];

    [arr, arr2].forEach(arr => {
        if(arr !==null){
        arr.forEach(obj => {
          const { yyyymm, engId, consUsageVal } = obj;
          const index = result.findIndex(item => item.yyyymm === yyyymm);
          if (index === -1) {
            result.push({ yyyymm, data: [{ engId, consUsageVal }] });
          } else {
            result[index].data.push({ engId, consUsageVal });
          }
        })
      };
    });

    result.forEach((obj) => {
      obj.data.sort((a, b) => a.engId.localeCompare(b.engId));
    });

    setResultArr(result);
  }
  

  const makeSeries = () => {
    const series = [];
    const values = resultArr;
    if (values) {
      const colors = ["rgb(124, 181, 236)","rgb(67, 67, 72)", ];

      for (const [index, value] of Object.entries(values)) {
        const temp = {};
        const dataTemp = value.data;

        temp.type = 'column';
        temp.name = value.yyyymm;
        temp.color = colors[index % colors.length];

        const usageValArray = dataTemp.map(obj => obj.usageVal);
        if(thisMon[engId]!=null)
        {
          temp.data = [thisMon[engId].consUsageVal];
        }
        

        temp.dataLabels = {
          enabled: true,
          formatter: function () {
            var yValue = Highcharts.numberFormat(this.y, 0, '.', ','); // 천단위 쉼표 추가
            var pointIndex = this.point.index;
            var units = [' Nm3', ' m3', ' kWh', ' kg'];
            //var unit = units[pointIndex];
            var unit = engUnit;
            
            return yValue + unit;
          }
        }

        series.push(temp);
      }
    }
    return series;
  }

  const makeEnergyId = () => {
    let categories;
    const values = resultArr;

    if (values) {
      for (const value of Object.values(values)) {
        const temp = {};
        const dataTemp = value.data;
        const engIdArray = dataTemp.map(obj => obj.engId);
        let engNameArr = null;

        engNameArr = engIdArray.map(target => engList.find(obj => obj.engId === target))
          .map(obj => obj.engName);
        categories = engNameArr;
      }
    }
    return categories;
  }

  const getChartData = (title) => {
    return {
      title: {
        text: "",
        align: "center",
      },
      legend: {
        enabled: true,
        itemStyle: {
          color: '#FFFFFF',
          fontWeight: 'thin',
          fontSize: '15px'
        },
        squareSymbol: true,
        padding: 0,
        symbolWidth: 0,
        symbolPadding: 14,
        layout: 'horizontal'
      },
      plotOptions: {
        series: {
          animation: true,
          dataLabels: {
            enabled: true,
            style: {
              color: "white",
              fontSize: "15px",
              fontWeight: "normal",
              textOutline: "1px 1px",
            },
          },
        },
         column: {pointWidth: 120}  // bar 너비 조정
        //makeEnergyId()''
      },
      xAxis: {
        categories: [engName],
        labels: {
          style: {
            color: 'white',
            fontSize: '15px'
          }
        },
        crosshair: true,
        lineWidth: 1,
        lineColor: "#a9b0c1",
        gridLineColor: "#666666",
        tickColor: "#666666",
      },
      yAxis: {
        title: {
          text: "",
        },
        lineWidth: 0,
        lineColor: "#666666",
        gridLineColor: "#666666",
      },
      tooltip: {
        headerFormat: '<b>{point.key}</b><br/><table>',
        pointFormatter: function () {
          var yValue = this.y;
          var units = {
            "압공": " Nm3",
            "냉수": " m³",
            "전력": " kWh",
            "스팀": " kg"
          };
          var unit = units[this.category] || ''; // 해당 카테고리에 대한 단위가 없을 경우, 빈 문자열

          return '<tr><td style="color:' + this.color + ';padding:0">' + '●' + '</td>' +
            '<td style="padding:0"><b>' + Highcharts.numberFormat(yValue, 0, '.', ',') + unit + '</b></td></tr>';
        },
        shared: true,
        useHTML: true
      },
      chart: {
        backgroundColor: "#313131",
        borderWidth: 1,
        borderRadius: 0,
        borderColor: "#303030",
        plotBackgroundColor: "#303030",
        plotBorderWidth: 1,
        plotBorderColor: "#303030",
        width: 300,
      },
      credits: {
        enabled: false,
      },
      series: makeSeries()
    };
  }

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={getChartData('', '', '', '')}
    />
  );

}